import * as API from '..'

export default {
  getContractList(params) {
    return API.POST(process.env.serverV1 + '/contract/page-list', params)
  },

  handleDowuloadFile(params) {
    return API.POSTBLOB(process.env.serverV1 + '/contract/download', params)
  },
}




// WEBPACK FOOTER //
// ./src/api/api_contract/api_contract.js